<template lang="pug">
    div.hidden

        // main
        el-form-item(prop="event")
</template>

<script>

export default {
    name: 'AllInputFields',
}
</script>
